import { hucId } from "../hooks/useRasterMetadata";

export type RasterResolution = 10 | 30 | 90

export function getRasterDownloadUrl(hucId: hucId, resolution: RasterResolution): string {
    return `./api/?hucId=${hucId}&resolution=${resolution}`
}

export default getRasterDownloadUrl;
